import React from 'react';
import { classNames } from './classNames';

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  id: string;
  label: React.ReactNode;
  inline?: boolean;
  wrapperClassName?: string;
  labelClassName?: string;
}

const Radio = React.forwardRef<HTMLInputElement, RadioProps>(({
  id,
  label,
  inline = false,
  wrapperClassName,
  labelClassName,
  className,
  ...props
}, ref) => (
  <div className={classNames('form-check', inline ? 'form-check-inline' : undefined, wrapperClassName)}>
    <input
      ref={ref}
      id={id}
      type="radio"
      className={classNames('form-check-input', className)}
      {...props}
    />
    <label className={classNames('form-check-label', labelClassName)} htmlFor={id}>
      {label}
    </label>
  </div>
));

Radio.displayName = 'Radio';

export default Radio;

